import script from "./SignatureInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignatureInput.vue?vue&type=script&setup=true&lang=ts"

import "./SignatureInput.vue?vue&type=style&index=0&id=1e86df93&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e86df93"]])

export default __exports__